// extracted by mini-css-extract-plugin
export default {"productImage":"editProduct_productImage__Vq-zv"};